import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import unpermittedADURisksImage from '@/assets/unpermitted-adu-risks.jpg';

const WhatAreRisksRentingUnpermittedADUCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/risks-unpermitted-adu-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={unpermittedADURisksImage} 
              alt="City inspector issuing violation notice" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              What Are the Risks of Renting an Unpermitted ADU in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Learn about the serious risks and legal implications of renting out an unpermitted ADU in California, and how to address compliance issues effectively.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Legal Consequences of Renting Unpermitted ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Renting unpermitted ADUs violates California housing codes and can result in cease-and-desist orders, forced tenant evictions, and substantial legal liability. Cities can issue stop-work orders, require immediate tenant relocation, and pursue legal action for code violations. Property owners face potential criminal charges for illegal rental activities and unsafe housing conditions.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Financial Risks and Penalties
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Unpermitted ADU rentals expose owners to daily fines ranging from $100-$1,000+ until compliance is achieved. Insurance claims may be denied for unpermitted structures, leaving owners liable for property damage and tenant injuries. Retroactive permitting costs, required upgrades, and potential tenant relocation expenses can exceed $50,000-$100,000 in severe cases.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Steps to Legalize an Unpermitted ADU
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Legalizing unpermitted ADUs requires immediate cessation of rental activities, professional code assessment, and retroactive permit applications. Owners must upgrade electrical, plumbing, and structural systems to current codes, obtain required inspections, and pay penalty fees. Professional consultation with contractors and permit expeditors helps navigate complex legalization processes efficiently.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Can cities penalize homeowners renting unpermitted ADUs?</p>
                  <p>A: Yes, fines, penalties, and eviction actions can result from renting unpermitted units.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: How can I legally resolve my unpermitted ADU rental?</p>
                  <p>A: Work with your city to obtain retroactive permits and ensure code compliance promptly.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default WhatAreRisksRentingUnpermittedADUCalifornia;